import { useState } from "react";
import { Box, Typography } from "@mui/material";

import ReachLogo from "../../../assets/Logos/reach_logo.png";
import "./PanelSidebar.scss";

import { Lightbulb, Hospital, HeartPulse, Shapes, ChartColumnBig } from "lucide-react";

interface sidebarOptions {
	icon: React.ReactNode;
	text: string;
	isSelected: boolean;
	menu: string;
}

interface sidebarProps {
	updateContent: (menu: string) => void;
}

export default function PanelSidebar({ updateContent }: sidebarProps) {
	const [sidebarOptions, setSidebarOptions] = useState<sidebarOptions[]>([
		{
			icon: <Lightbulb className="option-icon" />,
			text: "Ideas",
			isSelected: true,
			menu: "ideas",
		},
		{
			icon: <Hospital className="option-icon" />,
			text: "Unidades",
			isSelected: false,
			menu: "units",
		},
		{
			icon: <HeartPulse className="option-icon" />,
			text: "Áreas",
			isSelected: false,
			menu: "areas",
		},
		{
			icon: <Shapes className="option-icon" />,
			text: "Categorías",
			isSelected: false,
			menu: "categories",
		},
		{
			icon: <ChartColumnBig className="option-icon" />,
			text: "KPIs",
			isSelected: false,
			menu: "kpis",
		},
	]);

	const changeMenu = (optionMenu: string) => {
		setSidebarOptions((prevOptions) =>
			prevOptions.map((option) => ({
				...option,
				isSelected: option.menu === optionMenu,
			})),
		);
		updateContent(optionMenu);
	};

	return (
		<Box className="sidebar">
			<img
				src={ReachLogo}
				className="sidebarLogo"
			/>

			<Box className="sidebarOptions">
				{sidebarOptions.map((option, index) => {
					var optionClasses = `sidebarOption ${
						option.isSelected ? "selected" : ""
					}`;
					return (
						<Box
							key={index}
							id={index.toString()}
							className={optionClasses}
							onClick={() => changeMenu(option.menu)}
						>
							{option.isSelected && <Box className="optionSelector" />}
							<Box className="optionIcon">{option.icon}</Box>
							<Typography className="optionText">{option.text}</Typography>
						</Box>
					);
				})}
			</Box>
		</Box>
	);
}
